import * as Yup from 'yup';

const Schema = Yup.object().shape({
  name: Yup.string().required(),
  aliases: Yup.array()
    .of(Yup.string())
    .required('You must enter in aliases for this function')
});

export const Form = {
  name: 'organization',
  validationSchema: Schema,
  fields: [
    {
      name: 'name',
      label: 'Name',
      placeholder: 'Defibrillator',
      required: true
    },
    {
      name: 'displayName',
      label: 'Display name',
      description: 'The name to display in the dosing card for this equipment',
      placeholder: 'Defibrilate'
    },
    {
      name: 'aliases',
      label: 'Aliases',
      type: 'tag'
    }
  ]
};
